import React, { memo, useEffect, useMemo, useState } from "react";
import SectionField from "../section/SectionField";
import styles from "./YesNoComponent.module.scss";
import InputTextArea from "components/shared/textArea/InputTextArea";
import FileUploadButton from "components/shared/fileUploadButton/FileUploadButton";
import { useForm, Controller } from "react-hook-form";
import TriggerButton from "components/shared/createTriggerButton/TriggerButton";
import { setUpdateDroppedItems } from "@redux/slices/formSlice";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeFirstLetter, evaluationFind, handleFile, randomIntFromInterval } from "utils/utils";
import { setDroppedItems } from "@redux/slices/formSlice";
import { setDroppedItems as setTriggerList } from "@redux/slices/triggerSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import { setPublish } from "@redux/slices/globalSlice";
import { useNavigate, useParams } from "react-router-dom";
import { MenuItem, Select } from "@mui/material";
import toast from "react-hot-toast";

const yesNoOptions = [
    "Pass",
    "Fail",
    "Pass or Fail",
    "Neutral",
]
const evaluationOptions = [
    "Pass",
    "Fail",
    "Neutral",
]


const YesNoComponent = () => {
    const { publish } = useSelector((state) => state?.global);
    const dispatch = useDispatch();
    const { triggerDroppedList } = useSelector((state) => state.trigger);

    const { droppedItems, selectedData } = useSelector((state) => state.form);
    const navigate = useNavigate()
    const [options, setOptions] = useState([]);
    const { formId } = useParams()
    const temp = useMemo(() => {
        return (obj = {}, iden) => {
            let lower = iden?.toLowerCase();
            let { passOn, failOn, neutralOn } = obj || {};

            if (passOn?.split(",").map(v => v.trim()?.toLowerCase()).includes(lower)) {
                return "Pass";
            }
            if (failOn?.split(",").map(v => v.trim()?.toLowerCase()).includes(lower)) {
                return "Fail";
            }
            if (neutralOn?.split(",").map(v => v.trim()?.toLowerCase()).includes(lower)) {
                return "Neutral";
            }
            return "";
        };
    }, []);

    const { register, control, watch, setValue: setValues, formState: { isDirty } } = useForm({
        defaultValues: {
            allowNA: selectedData?.options?.length == 3 ? true : false,
            enableDependentQuestions: selectedData?.whenEvaluationEquals ? true : false,
            options: selectedData?.options ? selectedData?.options : ["Yes", "No"],
            evaluation1: Object?.keys(selectedData?.evaluation || {})?.length ? temp(selectedData?.evaluation, "yes") : "Pass",
            evaluation2: Object?.keys(selectedData?.evaluation || {})?.length ? temp(selectedData?.evaluation, "no") : "Pass",
            evaluation3: Object?.keys(selectedData?.evaluation || {})?.length ? temp(selectedData?.evaluation, "n/a") : "Pass",
            whenEvaluationEquals: "",
            instructions: selectedData?.instructions || "",
            showInstructions: selectedData?.showInstructions || false
        },
    });


    const handleFileChange = (file, setIsLoading) => {
        handleFile(file, droppedItems, selectedData, dispatch, setDroppedItems, setIsLoading);
        dispatch(setPublish(true));
    };

    const handleImageDelete = (src, selectedItem) => {
        const updatedMedia = selectedItem?.data?.media.filter(
            (media) => media.path !== src
        );

        const updatedData = { media: updatedMedia };

        dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData }));
        dispatch(setPublish(true));
    };

    const handleOpenImage = (src) => {
        window.open(src, "__blank");
    };

    const currentItem = useMemo(() => {
        // Check for a match in the main fields
        let foundItem = droppedItems.find((item) => item.id === selectedData.id);

        if (!foundItem) {
            // If not found, search in dependent fields
            droppedItems.forEach((item) => {
                const dependentMatch = item.dependentField.find(
                    (depField) => depField.id === selectedData.id
                );
                if (dependentMatch) {
                    foundItem = dependentMatch;
                }
            });
        }

        return foundItem;
    }, [droppedItems, selectedData]);

    const handleTrigger = () => {
        const uniqueId = Date.now() + randomIntFromInterval(1000, 9999);
        dispatch(setTriggerList([
            ...triggerDroppedList, {
                ...currentItem,
                id: uniqueId
            }
        ]))
        navigate(`/create/triggers/${formId || ""}`)
    }

    const onValueChange = (data) => {
        let formData = structuredClone(data); // Deep clone the object

        if (formData.evaluation1 || formData.evaluation2 || formData.evaluation3) {
            let arr = [
                formData.evaluation1,
                formData.evaluation2,
                formData.evaluation3
            ];

            formData.evaluation = {
                passOn: evaluationFind("Pass", arr),
                failOn: evaluationFind("Fail", arr),
                neutralOn: evaluationFind("Neutral", arr)
            };
        } else {
            formData.evaluation = formData.evaluation || {};
        }

        dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData: formData }));
    };


    useEffect(() => {
        if (watch("allowNA")) {
            const updatedOptions = ["Yes", "No", "N/A"];
            setOptions(updatedOptions);
            setValues("options", updatedOptions);
            setValues("evaluation3", "Neutral");
        } else {
            const updatedOptions = ["Yes", "No"];
            setOptions(updatedOptions);
            setValues("options", updatedOptions);
            setValues("evaluation3", undefined);
        }
    }, [watch("allowNA")]);

    useEffect(() => {
        if (watch("enableDependentQuestions")) {
            if (selectedData?.whenEvaluationEquals) {

                setValues("whenEvaluationEquals", selectedData?.whenEvaluationEquals == "pass or fail" ? yesNoOptions[2] : capitalizeFirstLetter(selectedData?.whenEvaluationEquals))
            } else {
                setValues("whenEvaluationEquals", yesNoOptions[0])
            }
        } else {
            setValues("whenEvaluationEquals", "")
            let clearDrop = droppedItems?.map((e) => {
                return e?.id == selectedData?.id ? { ...e, dependentField: [] } : e
            })
            dispatch(setDroppedItems(clearDrop))
        }
    }, [watch("enableDependentQuestions")])

    useEffect(() => {
        if (!isDirty) {
            const data = structuredClone(watch())
            dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData: data }));
        }

        const subscription = watch((data) => {
            onValueChange(data);
            dispatch(setPublish(true))
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    return (
        <>
            <SectionField
                placeholder="Please enter your question here."
                message="Required"
            />

            <div className={styles?.instructionsForm}>
                <h4>Instructions</h4>
                <div className={styles?.formField}>
                    <Controller
                        name="instructions"
                        control={control}
                        render={({ field }) => (
                            <InputTextArea
                                {...field}
                                control={control}
                                type="textarea"
                                name="Optional"
                                placeholder="Optional"
                                onChange={(e) => {
                                    field.onChange(e);
                                    if (!e.target.value) setValues("showInstructions", false);
                                }}
                                className={styles.textArea}
                            />
                        )}
                    />
                </div>
                <div className={styles?.formField}>
                    {currentItem?.data?.media?.length ? (
                        <div className={styles.imageContainer}>
                            {currentItem?.data?.media?.map((src) => {
                                const fileExtension = src.path.split('.').pop().toLowerCase();

                                // Function to check if file is an image
                                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(fileExtension);
                                // Function to check if file is a video
                                const isVideo = ['mp4', 'webm', 'ogg'].includes(fileExtension);

                                return (
                                    <div className={styles.imageWrapper} onClick={() => handleOpenImage(src.path)}>
                                        {isImage ? (
                                            <img src={src.path} alt="" />
                                        ) : isVideo ? (
                                            <video width="320" height="240" controls>
                                                <source src={src.path} type={`video/${fileExtension}`} />
                                                Your browser does not support the video tag.
                                            </video>
                                        ) : null}

                                        <div
                                            className={styles.cancelIcon}
                                            onClick={(event) => {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                handleImageDelete(src.path, currentItem);
                                            }}
                                        >
                                            <DeleteIcon sx={{ width: "20px", height: "20px" }} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <FileUploadButton
                            name="mediaFile"
                            control={control}
                            onFileChange={handleFileChange}
                        />
                    )}
                </div>
            </div>

            <form className={styles.formContainer}>
                <div>
                    <label>
                        <Controller
                            name={`showInstructions`}
                            control={control}
                            render={({ field }) => (
                                <input
                                    type="checkbox"
                                    {...field}
                                    checked={field.value}
                                    onChange={(e) => {
                                        field.onChange(e)
                                        dispatch(setPublish(true))
                                    }}
                                />
                            )}
                        />
                        Show instructions by default
                    </label>
                </div>

                <div className={styles.answersContainer}>
                    <div className={styles.answersContainerHead}>
                        <h4>Answers</h4>
                        <div>
                            <label>
                                <Controller
                                    name={"allowNA"}
                                    control={control}
                                    render={({ field }) => (

                                        <input
                                            type="checkbox"
                                            {...field}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                dispatch(setPublish(true))
                                            }}

                                            checked={field.value}
                                        />

                                    )}
                                />


                                Allow N/A
                            </label>
                        </div>
                    </div>

                    {options.map((label, index) => (
                        <div key={label} className={styles.answerRow}>
                            <input type="text" disabled value={label} readOnly {...register(`options.${index}`)} />
                            <Controller
                                name={`evaluation${index + 1}`}
                                control={control}
                                render={({ field }) => (
                                    <select
                                        disabled={index == 2}
                                        {...field}
                                        onChange={(e) => {
                                            field.onChange(e);
                                            dispatch(setPublish(true))
                                        }}
                                    >
                                        {
                                            evaluationOptions?.map((option) => {
                                                return <option value={option}>{option}</option>
                                            })
                                        }
                                    </select>
                                )}
                            />
                        </div>
                    ))}
                </div>

                <div>
                    <label>
                        <Controller
                            name={`enableDependentQuestions`}
                            control={control}
                            render={({ field }) => (
                                <input
                                    type="checkbox"
                                    {...field}
                                    checked={field.value}
                                    onChange={(e) => {
                                        if (!e.target.checked) {
                                            if (window.confirm("Un-checking this option will remove all dependent questions and any data collected from those questions. Are you sure?")) {
                                                field.onChange(e)
                                                dispatch(setPublish(true))
                                            } else {
                                                return
                                            }
                                        }
                                        field.onChange(e)
                                        dispatch(setPublish(true))
                                    }}
                                />


                            )}
                        />
                        Enable Dependent Questions

                    </label>
                    {
                        watch("enableDependentQuestions") ? <>
                            <label style={{ margin: "10px 0px" }}>Display when answer evaluates to:</label>
                            <div>
                                <Controller

                                    name="whenEvaluationEquals"
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            sx={{ width: "100%" }}
                                            {...field}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                dispatch(setPublish(true))
                                            }}
                                        >
                                            {
                                                yesNoOptions?.map((option) => {
                                                    return <MenuItem value={option}>{option}</MenuItem>
                                                })

                                            }
                                        </Select>

                                    )}

                                />
                            </div>


                        </> : null

                    }
                </div>

                <TriggerButton handleClick={() => {
                    if (!publish) {
                        handleTrigger()
                    } else {
                        toast.error("There are unpublished changes");
                    }
                }

                } />
            </form>
        </>
    );
};

export default memo(YesNoComponent);
